export default "__VITE_ASSET__BKCiVh9m__"